// extracted by mini-css-extract-plugin
export default {"dialogWrapperRoot":"_10NI_82N8Vc_BZgSCUckF4","paperFullScreen":"_1UCq7omUEEn_7plLTLHsB"};